import { useMemo } from 'react'

import { routes, useLocation, useParams } from '@cedarjs/router'

import Navigation, { NavElement } from 'src/components/Sidebar/Navigation/Navigation'

const SettingsNavItem = () => {
  const { pathname } = useLocation()
  const { taskTemplateId, recordTemplateUuid, recordTypeId, feeScheduleId } = useParams()

  const settingsRoutes: string[] = [
    routes.documentTemplates(),
    routes.emailTemplates(),
    routes.feeSchedules(),
    routes.holidays(),
    routes.inspectionCalendars(),
    routes.inspectionTemplates(),
    routes.modules(),
    routes.organization(),
    routes.settings(),
    routes.taskTemplates(),
    routes.violationSettings(),
  ]

  if (recordTemplateUuid) {
    settingsRoutes.push(routes.recordTemplateConfiguration({ recordTemplateUuid }))
  }
  if (taskTemplateId) {
    settingsRoutes.push(routes.taskTemplate({ taskTemplateId: parseInt(taskTemplateId) }))
  }
  if (recordTypeId) {
    settingsRoutes.push(routes.module({ recordTypeId: parseInt(recordTypeId) }))
  }
  if (feeScheduleId) {
    settingsRoutes.push(routes.feeScheduleDetail({ feeScheduleId: parseInt(feeScheduleId) }))
  }

  const isSettingsActive = settingsRoutes.includes(pathname as string)

  const navElements: NavElement[] = useMemo(
    () => [
      {
        icon: 'FaGear',
        internalRoute: routes.settings(),
        isActive: isSettingsActive,
        title: 'Settings',
      },
    ],
    [isSettingsActive]
  )

  return <Navigation elements={navElements} />
}

export default React.memo(SettingsNavItem)
